import styled from '@emotion/styled'
import { ApiClient } from '@storefronts/common-types'
import {
    ACCENT_FILL_COLOR_VAR,
    ACCENT_TEXT_COLOR_VAR,
} from '../../context/CustomizationContextProvider'

export const brandName = (client: ApiClient) =>
    client.displayName || client.name

// A square mark reads at avatar size; a wide wordmark does not.
export const BrandAvatar: React.FC<{ client: ApiClient; size: number }> = ({
    client,
    size,
}) => {
    const src = client.favicon ?? client.imageUrl ?? client.logoImageUrl
    return src ? (
        <AvatarImage src={src} alt="" style={{ width: size, height: size }} />
    ) : (
        <AvatarInitial
            style={{ width: size, height: size, fontSize: size * 0.45 }}
        >
            {brandName(client).slice(0, 1).toUpperCase()}
        </AvatarInitial>
    )
}

const AvatarImage = styled.img`
    flex: none;
    border-radius: 50%;
    object-fit: cover;
    background: #ffffff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
`

const AvatarInitial = styled.span`
    flex: none;
    border-radius: 50%;
    background: var(${ACCENT_FILL_COLOR_VAR}, #0d0d0d);
    color: var(${ACCENT_TEXT_COLOR_VAR}, #ffffff);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
`
